import React from 'react';
import { useForm } from 'react-hook-form';

/* Components */
import { CircularProgress } from '@material-ui/core';
import WithFlow from 'conversie-flow-bundle/assets/js/components/flow/WithFlow';
import ConversionFlowForm from './ConversionFlowForm';
import ConversionProgress from './ConversionProgress';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionInPage({rating, updateUrl, usps}) {
    const { ...form } = useForm({ shouldUnregister: true });
    const monthlyPrice = sessionStorage.getItem('monthly') ? sessionStorage.getItem('monthly') : '';

    return (
        <WithFlow
            flowUrl={monthlyPrice ? `${updateUrl}&monthly=${monthlyPrice}` : updateUrl}
            flow={null}
            translate={trans}
        >
            {(passProps) => {
                const { flow, doRequest, setStep } = passProps;
                const activeStep = flow?.steps?.find((step) => step.active);

                if (activeStep?.last && passProps.status === 'idle' && flow.redirectUrl && flow.redirectUrl !== '') {
                    window.location = flow.redirectUrl;
                }

                return (
                    <>
                        {(flow && flow.steps) && (
                            <ConversionProgress steps={flow.steps.filter((step) => step.name !== 'Bedankt')} activeStep={activeStep} setStep={setStep} />
                        )}
                        {(flow && !flow.showLoaderBeforeRedirect) && (
                            <ConversionFlowForm
                                {...passProps}
                                form={form}
                                flow={flow}
                                flowStep={activeStep}
                                rating={rating}
                                usps={usps}
                                doRequest={doRequest}
                            />
                        )}
                        {(!flow || (flow && flow.showLoaderBeforeRedirect)) && (
                            <CircularProgress
                                classes={{
                                    root: "loading loading--circular m-auto",
                                }}
                            />
                        )}
                    </>
                )
            }}
        </WithFlow >
    )
}
